<template>
  <div>
    <div class="mt-8 lg:mb-4">
      <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-2">{{ $tc('invoices.metadatos.metadato', 2) }}</h3>
      <el-table ref="metadatos" :data="metadatos" style="width: 100%" :empty-text="$t('app.no_data_text')" :show-header="metadatos && metadatos.length > 0">
        <el-table-column prop="Campo" :label="$t('invoices.metadatos.metadato_campo')" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="Valor" :label="$t('invoices.metadatos.metadato_valor')" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="actions" align="center" label="">
          <template slot-scope="scope">
            <div class="flex flex-row-reverse" v-if="showActions">
              <base-button-icon v-for="action in finalActions" :key="action.name" @click="doAction(action.callback, scope.row)"
                :name="action.name" mode="core" size="xs" />
              <!-- <base-button-icon v-if="showActions" @click="editMetadatoAdicional(scope.row)" name="editpencil" mode="core"
                size="xs" />
              <base-button-icon v-if="showActions" @click="deleteMetadatoAdicional(scope.row)" name="trash" mode="core"
                size="xs" /> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="w-full m-2 float-right">
      <base-button-responsive v-if="showActions" mode="primary" :text="$t('invoices.metadatos.new_metadato')"
        @click="newMetadato()" icon="plus" class="m-5 float-right" />
    </div>

    <invoice-new-metadata-dialog 
      :dialogOpen="showNewMetadato" 
      :idFacturae="this.idFacturae" 
      :idInvoice="this.idInvoice"
      :idCliente="this.idCliente" 
      @toggleDialog="toggleDialogMetadato" 
      @applyDialog="applyDialogMetadatoHandler" />
    <invoice-update-metadata-dialog 
      :dialogOpen="showUpdateMetadato" 
      :campo="this.selectedUpdateMetadataCampo"
      :valorDefecto="this.selectedUpdateMetadataValor" 
      :metadataId="this.selectedUpdateMetadataId"
      :idCliente="this.idCliente" 
      @toggleDialog="toggleDialogUpdateMetadato" 
      @applyDialog="applyDialogUpdateMetadatoHandler" />
  </div>
</template>

<script>
import { i18n } from '@/i18n'
import InvoiceNewMetadataDialog from '@/components/InvoiceNewMetadataDialog.vue'
import InvoiceUpdateMetadataDialog from '@/components/InvoiceUpdateMetadataDialog.vue'

import { deleteMetadatoInvoice } from '@/services/configurations/deleteMetadatoInvoice'
export default {
  name: 'metadatos-table-view',
  components: {
    InvoiceNewMetadataDialog,
    InvoiceUpdateMetadataDialog
  },
  props: {
    showActions: {
      type: Boolean,
      default: false,
    },
    idCliente: {
      type: Number,
      default: -1,
    },
    idFacturae: {
      type: Number,
      default: -1,
    },
    idInvoice: {
      type: Number,
      default: -1,
    },
    metadatos: {
      type: Array,
      default: () => []
    },
    actions: {
      type: Array,
      default: () => []
    },
  },
  data: function () {
    return {
      showNewMetadato: false,
      showUpdateMetadato: false,
      selectedUpdateMetadataId: -1,
      selectedUpdateMetadataCampo: '',
      selectedUpdateMetadataValor: '',
      basicActions: [
        // { callback: this.deleteMetadatoAdicional, name: 'link' },
        { callback: this.editMetadatoAdicional, name: 'editpencil' },
        { callback: this.deleteMetadatoAdicional, name: 'trash' },
      ],
    }
  },
  computed: {
    finalActions: function () {
      return this.basicActions.concat(this.actions).filter(x => typeof x.callback === 'function' && typeof x.name === 'string').reverse()
    }
  },
  methods: {
    doAction: function (callback, row) {
      if (this.showActions) {
        callback(row)
      }
    },
    newMetadato: async function () {
      this.toggleDialogMetadato()
    },
    linkMetadatoAdicional: function (row) {

    },
    editMetadatoAdicional: async function (row) {
      this.selectedUpdateMetadataId = { idFacturae: this.idFacturae, idInvoice: this.idInvoice, Campo: row.Campo }
      this.selectedUpdateMetadataCampo = row.Campo
      this.selectedUpdateMetadataValor = row.Valor
      this.toggleDialogUpdateMetadato()
    },
    deleteMetadatoAdicional: async function (row) {
      try {
        this.$store.commit('app/setLoading', true)
        const response = await deleteMetadatoInvoice({ idFacturae: this.idFacturae, idInvoice: this.idInvoice, Campo: row.Campo })
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.metadato_deleted_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('app/setLoading', false)
        this.$emit('updateDataTable')
      }
    },
    toggleDialogMetadato: function () {
      this.showNewMetadato = !this.showNewMetadato
    },
    toggleDialogUpdateMetadato: function () {
      this.showUpdateMetadato = !this.showUpdateMetadato
    },
    applyDialogMetadatoHandler: async function () {
      this.toggleDialogMetadato()
      if (this.showActions) {
        this.$emit('updateDataTable')
      }
    },
    applyDialogUpdateMetadatoHandler: async function () {
      this.toggleDialogUpdateMetadato()
      if (this.showActions) {
        this.$emit('updateDataTable')
      }
    },
  },
}
</script>

<style></style>
